import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../lib/theme';
import { IconButton } from './IconButton';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  return (
    <IconButton
      icon={theme === 'dark' ? Sun : Moon}
      label={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
      size="sm"
      tooltipSide="bottom"
      onClick={toggleTheme}
    />
  );
}
